/* eslint-disable react/prop-types */
import React from 'react';

const GetSchoolName = ({ schoolName }) => {
  if (schoolName.search('Senior High School') !== -1 && schoolName.endsWith('Senior High School')) {
    return (
      <>
        {schoolName.replace('Senior High School', '')}
        <span className="high-school-text">Senior High School</span>
      </>
    );
  }
  if (schoolName.search('High School') !== -1 && schoolName.endsWith('High School')) {
    return (
      <>
        {schoolName.replace('High School', '')}
        <span className="high-school-text">High School</span>
      </>
    );
  }
  if (schoolName.search('Middle School') !== -1 && schoolName.endsWith('Middle School')) {
    return (
      <>
        {schoolName.replace('Middle School', '')}
        <span className="high-school-text">Middle School</span>
      </>
    );
  }
  if (schoolName.search('School') !== -1 && schoolName.endsWith('School')) {
    return (
      <>
        {schoolName.replace('School', '')}
        <span className="high-school-text">School</span>
      </>
    );
  }
  return (
    <>
      {schoolName}
    </>
  );
};

export default GetSchoolName;
